import { Component, Input } from '@angular/core';
import { DynamicProperties, EmployerDto } from '../../../../../service/dto';

@Component({
  selector: 'app-employer-view-details',
  standalone: false,
  templateUrl: './employer-view-details.component.html',
  styleUrl: './employer-view-details.component.scss'
})
export class EmployerViewDetailsComponent {
	@Input() employer!: EmployerDto;

	getDynamicProperties(properties: DynamicProperties): string[]{
		return Object.keys(this.employer.properties);
	}
}
